import Layout from '../core/ui/layout/Layout';

const HomePage = () => {
  return <Layout>HomePage</Layout>;
};

export default HomePage;
